export const API_PREFIX = '/api';

export const ENDPOINTS = {
  catalog: {
    databases: API_PREFIX + '/catalog/databases',
    database: (db: string) => API_PREFIX + '/catalog/databases/' + db,
    databaseTables: (db: string) => API_PREFIX + '/catalog/databases/' + db + '/tables',
    tables: API_PREFIX + '/catalog/tables',
    table: (tableId: string) => API_PREFIX + '/catalog/tables/' + tableId,
    tableSchema: (tableId: string) => API_PREFIX + '/catalog/tables/' + tableId + '/schema',
    tableLineage: (tableId: string) => API_PREFIX + '/catalog/tables/' + tableId + '/lineage',
    tableSample: (tableId: string) => API_PREFIX + '/catalog/tables/' + tableId + '/sample',
    tableSync: (tableId: string) => API_PREFIX + '/catalog/tables/' + tableId + '/sync',
    tableStats: (tableId: string) => API_PREFIX + '/catalog/tables/' + tableId + '/stats',
    health: API_PREFIX + '/catalog/health',
  },
  bronze: {
    tables: API_PREFIX + '/bronze',
    table: (table: string) => API_PREFIX + '/bronze/' + table,
    tableSample: (table: string) => API_PREFIX + '/bronze/' + table + '/sample',
    tableStats: (table: string) => API_PREFIX + '/bronze/' + table + '/stats',
    tableHistory: (table: string) => API_PREFIX + '/bronze/' + table + '/history',
    tablePartitions: (table: string) => API_PREFIX + '/bronze/' + table + '/partitions',
    tablePartition: (table: string, date: string) =>
      API_PREFIX + '/bronze/' + table + '/partitions/' + date,
    vacuum: (table: string) => API_PREFIX + '/bronze/' + table + '/vacuum',
    ingestJson: API_PREFIX + '/bronze/ingest/json',
    ingestCsv: API_PREFIX + '/bronze/ingest/csv',
    ingestStream: (topic: string) => API_PREFIX + '/bronze/ingest/stream/' + topic,
    jobs: API_PREFIX + '/bronze/jobs',
    jobsStats: API_PREFIX + '/bronze/jobs/stats',
    job: (jobId: string) => API_PREFIX + '/bronze/jobs/' + jobId,
  },
  silver: {
    tables: API_PREFIX + '/silver',
    table: (table: string) => API_PREFIX + '/silver/' + table,
    tableSample: (table: string) => API_PREFIX + '/silver/' + table + '/sample',
    tableStats: (table: string) => API_PREFIX + '/silver/' + table + '/stats',
    tableHistory: (table: string) => API_PREFIX + '/silver/' + table + '/history',
    tablePartitions: (table: string) => API_PREFIX + '/silver/' + table + '/partitions',
    tableDiff: (table: string, v1: string, v2: string) =>
      API_PREFIX + '/silver/' + table + '/diff/' + v1 + '/' + v2,
    tableTimeTravel: (table: string, version: string) =>
      API_PREFIX + '/silver/' + table + '/time-travel/' + version,
    tableRefresh: (table: string) => API_PREFIX + '/silver/' + table + '/refresh',
    tableTransform: (table: string) => API_PREFIX + '/silver/' + table + '/transform',
    transformAll: API_PREFIX + '/silver/transform/all',
    jobs: API_PREFIX + '/silver/jobs',
    jobsStats: API_PREFIX + '/silver/jobs/stats',
    job: (jobId: string) => API_PREFIX + '/silver/jobs/' + jobId,
  },
  gold: {
    tables: API_PREFIX + '/gold',
    table: (table: string) => API_PREFIX + '/gold/' + table,
    tableSample: (table: string) => API_PREFIX + '/gold/' + table + '/sample',
    tableStats: (table: string) => API_PREFIX + '/gold/' + table + '/stats',
    tableHistory: (table: string) => API_PREFIX + '/gold/' + table + '/history',
    tableLineage: (table: string) => API_PREFIX + '/gold/' + table + '/lineage',
    tableAggregate: (table: string) => API_PREFIX + '/gold/' + table + '/aggregate',
    tableRefresh: (table: string) => API_PREFIX + '/gold/' + table + '/refresh',
    aggregateAll: API_PREFIX + '/gold/aggregate/all',
    jobs: API_PREFIX + '/gold/jobs',
    jobsStats: API_PREFIX + '/gold/jobs/stats',
    job: (jobId: string) => API_PREFIX + '/gold/jobs/' + jobId,
    queries: {
      categoryRevenue: API_PREFIX + '/gold/queries/category-revenue',
      businessMetrics: API_PREFIX + '/gold/queries/business-metrics',
      customerAnalytics: API_PREFIX + '/gold/queries/customer-analytics',
      productPerformance: API_PREFIX + '/gold/queries/product-performance',
      adHoc: API_PREFIX + '/gold/queries/ad-hoc',
    },
  },
  kafka: {
    topics: API_PREFIX + '/kafka/topics',
    topic: (topic: string) => API_PREFIX + '/kafka/topics/' + topic,
    topicMessages: (topic: string) => API_PREFIX + '/kafka/topics/' + topic + '/messages',
    topicProduce: (topic: string) => API_PREFIX + '/kafka/topics/' + topic + '/produce',
    topicProduceBatch: (topic: string) => API_PREFIX + '/kafka/topics/' + topic + '/produce-batch',
    consumerGroups: API_PREFIX + '/kafka/consumer-groups',
    consumerGroup: (groupId: string) => API_PREFIX + '/kafka/consumer-groups/' + groupId,
    consumerGroupLag: (groupId: string) => API_PREFIX + '/kafka/consumer-groups/' + groupId + '/lag',
    consumerGroupReset: (groupId: string) =>
      API_PREFIX + '/kafka/consumer-groups/' + groupId + '/reset-offset',
    cluster: API_PREFIX + '/kafka/cluster',
    stats: API_PREFIX + '/kafka/stats',
  },
  airflow: {
    dags: API_PREFIX + '/airflow/dags',
    dag: (dagId: string) => API_PREFIX + '/airflow/dags/' + dagId,
    dagTrigger: (dagId: string) => API_PREFIX + '/airflow/dags/' + dagId + '/trigger',
    dagPreflight: (dagId: string) => API_PREFIX + '/airflow/dags/' + dagId + '/preflight',
    dagConfSpec: (dagId: string) => API_PREFIX + '/airflow/dags/' + dagId + '/conf-spec',
    dagPause: (dagId: string) => API_PREFIX + '/airflow/dags/' + dagId + '/pause',
    dagUnpause: (dagId: string) => API_PREFIX + '/airflow/dags/' + dagId + '/unpause',
    dagRuns: (dagId: string) => API_PREFIX + '/airflow/dags/' + dagId + '/runs',
    dagRun: (dagId: string, runId: string) => API_PREFIX + '/airflow/dags/' + dagId + '/runs/' + runId,
    dagRunTasks: (dagId: string, runId: string) =>
      API_PREFIX + '/airflow/dags/' + dagId + '/runs/' + runId + '/tasks',
    dagRunTaskLogs: (dagId: string, runId: string, taskId: string) =>
      API_PREFIX + '/airflow/dags/' + dagId + '/runs/' + runId + '/tasks/' + taskId + '/logs',
    dagRunGantt: (dagId: string, runId: string) =>
      API_PREFIX + '/airflow/dags/' + dagId + '/runs/' + runId + '/gantt',
    health: API_PREFIX + '/airflow/health',
    stats: API_PREFIX + '/airflow/stats',
  },
  crawler: {
    jobs: API_PREFIX + '/crawler',
    job: (name: string) => API_PREFIX + '/crawler/' + name,
    jobConfig: (name: string) => API_PREFIX + '/crawler/' + name + '/config',
    jobKafkaTopic: (name: string) => API_PREFIX + '/crawler/' + name + '/kafka-topic',
    jobRun: (name: string) => API_PREFIX + '/crawler/' + name + '/run',
    jobRunAsync: (name: string) => API_PREFIX + '/crawler/' + name + '/run-async',
    jobStop: (name: string) => API_PREFIX + '/crawler/' + name + '/stop',
    jobPreview: (name: string) => API_PREFIX + '/crawler/' + name + '/preview',
    jobRuns: (name: string) => API_PREFIX + '/crawler/' + name + '/runs',
    jobRun_: (name: string, runId: string) => API_PREFIX + '/crawler/' + name + '/runs/' + runId,
    jobRunItems: (name: string, runId: string) =>
      API_PREFIX + '/crawler/' + name + '/runs/' + runId + '/items',
    stats: API_PREFIX + '/crawler/stats',
  },
  eda: {
    profiles: API_PREFIX + '/eda/profiles',
    profile: (profileId: string) => API_PREFIX + '/eda/profiles/' + profileId,
    profileColumns: (profileId: string) =>
      API_PREFIX + '/eda/profiles/' + profileId + '/columns',
    profileCharts: (profileId: string) =>
      API_PREFIX + '/eda/profiles/' + profileId + '/charts',
    profileChart: (profileId: string, chartId: string) =>
      API_PREFIX + '/eda/profiles/' + profileId + '/charts/' + chartId,
    profileSample: (profileId: string) =>
      API_PREFIX + '/eda/profiles/' + profileId + '/sample',
    compare: API_PREFIX + '/eda/compare',
    proposeRule: API_PREFIX + '/eda/propose-rule',
  },
  dq: {
    rules: API_PREFIX + '/dq/rules',
    rule: (ruleId: string) => API_PREFIX + '/dq/rules/' + ruleId,
    ruleRun: (ruleId: string) => API_PREFIX + '/dq/rules/' + ruleId + '/run',
    runSuite: API_PREFIX + '/dq/run-suite',
    presets: API_PREFIX + '/dq/presets',
    presetCheck: (presetId: string) => API_PREFIX + '/dq/presets/' + presetId + '/check',
    presetApply: (presetId: string) => API_PREFIX + '/dq/presets/' + presetId + '/apply',
    runs: API_PREFIX + '/dq/runs',
    run: (runId: string) => API_PREFIX + '/dq/runs/' + runId,
    runSamples: (runId: string) => API_PREFIX + '/dq/runs/' + runId + '/samples',
    summary: API_PREFIX + '/dq/summary',
  },
  health: {
    root: API_PREFIX + '/health',
    deep: API_PREFIX + '/health/deep',
  },
  info: {
    root: API_PREFIX + '/info',
  },
  dashboard: {
    summary: API_PREFIX + '/dashboard/summary',
    activity: API_PREFIX + '/dashboard/activity',
    dependencies: API_PREFIX + '/dashboard/dependencies',
  },
} as const;
